import React, { FC } from 'react';
import { ServiceCardIconType } from '../../../models/Common';
import { AccountIcon } from '../icons/AccountIcon';

interface ServiceCardProps {
  iconType: ServiceCardIconType;
}

export const ServiceCard: FC<ServiceCardProps> = ({ iconType, children }) => {
  return (
    <div className="service-card card card__primary">
      <div className="service-card__container">
        <div className="service-card__container__icon">
          <AccountIcon accountType={iconType} />
        </div>
        <div className="service-card__container__content">{children}</div>
      </div>
    </div>
  );
};
